import React, { useEffect } from "react";
import * as Yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
// @mui
import { LoadingButton } from "@mui/lab";
import {
  Stack,
  Link,
  TextField,
  IconButton,
  InputAdornment,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import * as CompanyEmailValidator from "company-email-validator";
import { sendOtp, validateOtp } from "../PhoneInterviewApi";
import { validateEmail, validatePhoneNumber } from "../utils/utils";
//import { ga_pg_login_event } from "../../../../../utils/gaEvents";
//import { Link as RouterLink, useHistory } from "react-router-dom";
import CustomPhoneInput from "../CustomPhoneInput";
import InterviewOptions from "./InterviewOptions";
import { getPlaygroundCandidateDetails } from "../PhoneInterviewApi";
// ----------------------------------------------------------------------

const playgroundSlug = "playground";

const FormSchema = Yup.object().shape({
  otp: Yup.string().required("OTP is required").length(4, "OTP is invalid"),
});

type FormValuesProps = {
  email: string;
  phone: string;
  otp: string;
  name: string;
};

type OTPLoginType = "phone" | "email";

type OTPLoginProps = {
  isOpen: boolean;
  setIsOpen: (val) => void;
  onValidate?: () => void;
  loginType?: OTPLoginType;
};

export default function LoginForm({
  isOpen,
  setIsOpen,
  loginType = "phone",
  onValidate = null,
}: OTPLoginProps) {
  const [isOtpSent, setIsOtpSent] = React.useState<boolean>(false);
  const [isOtpValid, setIsOtpValid] = React.useState<boolean>(true);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [fetchError, setFetchError] = useState("");
  // let history = useHistory();
  const theme = useTheme();
  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isValid },
    setError,
    setValue,
    watch,
  } = useForm<FormValuesProps>({
    mode: "onChange",
    //resolver:  yupResolver(FormSchema),
    resolver: undefined,
    defaultValues: {
      email: "",
      phone: "",
      otp: "",
      name: "",
    },
  });
  const [interviewoptionvisible, setInterviewOptionVisible] = useState(false);
  let email = watch("email");
  let phone = watch("phone");
  let otp = watch("otp");
  let name = watch("name");

  const onSubmit = async (data: FormValuesProps) => {
    setIsLoading(true);
    validateOtp(email, phone, otp, name).then((res) => {
      setIsOtpValid(!res.error);

      if (!res.error) {
        if (!onValidate) {
          setInterviewOptionVisible(true);
          setIsOpen(false);
          /*getInterviewTypesForDemoCompany(playgroundSlug).then((interviews) => {
            history.push(
              `/playground/landing/?linkId=${
                interviews.find((x) => x.role_name === "New conversation")
                  ?.active_link
              }`
            );
          });
          setIsLoading(false);*/
          //ga_pg_login_event("email");
        } else {
          onValidate();
        }
      } else {
        setError("otp", { type: "invalid-otp", message: "OTP is invalid" });
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    setIsOtpSent(false);
  }, [isOpen]);
  useEffect(() => {
    getPlaygroundCandidateDetails()
      .then((res) => {
        console.log("These are fetched candidate details...", res);
        setValue("name", res?.name && res.name != "Error" ? res.name : "");
        setValue("phone", res?.phone_number ? res.phone_number : "");
        if (res.phone_number != null && res.phone_number != "") {
          setIsOpen(false);
          setInterviewOptionVisible(true);
        }
      })
      .catch((e) => console.log(e));
  }, []);
  /*This useEffect is present Only for testing 
  useEffect(() => {
    localStorage.setItem("babblebots_auth_data", "TestToken");
    setIsOpen(false);
    setInterviewOptionVisible(true);
    console.log(localStorage.getItem("babblebots_auth_data"));
  }, []);*/
  return (
    <>
      <Dialog
        open={isOpen}
        sx={{
          "& .MuiPaper-root": {
            width: "480px",
            maxWidth: "95vw",
            padding: "8px",
            margin: 0,
            backgroundColor: "white",
          },
        }}
      >
        <DialogTitle
          style={{
            textAlign: "center",
            marginBottom: "16px",
            color: "black", // White text for title
            backgroundColor: "#f6faff",
          }}
        >
          Welcome to Babblebots.ai Playground
          <Typography
            style={{
              color: "black",
              padding: "0px 5px",
              marginTop: "10px",
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            Talk to Eric - your AI-Recruiter! <br /> It takes just 2 minutes to
            transport you to a magical world of humanlike voice conversations
            and open thousands of possibilities!
          </Typography>
        </DialogTitle>

        <DialogContent
          className="modal-body"
          style={{
            alignItems: "flex-start",
            padding: "8px",
          }}
        >
          <form>
            <Stack
              spacing={2.5}
              alignItems="flex-start"
              sx={{ paddingTop: "12px" }}
            >
              {loginType == "email" ? (
                <Controller
                  name="email"
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      fullWidth
                      label="Login using your email"
                      disabled={isOtpSent}
                      error={Boolean(error)}
                      helperText={error?.message}
                    />
                  )}
                />
              ) : (
                <Stack
                  sx={{
                    minWidth: "100%",
                  }}
                  spacing={2}
                  direction="column"
                >
                  <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Enter Your Name"
                        sx={{
                          "& .MuiInputBase-input:hover": {
                            borderColor: "black !important",
                            color: "black",
                          },
                          "& .MuiInputBase-input": {
                            borderColor: "black !important",
                            color: "black",
                          },
                        }}
                      />
                    )}
                  />
                  <CustomPhoneInput
                    value={phone}
                    onChange={(val) => {
                      setValue("phone", val);
                    }}
                    defaultCountry={"US"}
                    inputProps={{
                      label: "Phone Number",
                      variant: "standard",
                    }}
                  />
                </Stack>
              )}
              {!isOtpSent && (
                <LoadingButton
                  fullWidth
                  size="large"
                  disabled={
                    loginType == "email"
                      ? !email ||
                        !validateEmail(email) ||
                        !CompanyEmailValidator.isCompanyEmail(email)
                      : !phone || !validatePhoneNumber(phone)
                  }
                  sx={{
                    "&.Mui-disabled": {
                      backgroundColor: "rgba(200, 200, 200, 0.6)",
                      color: "rgba(200, 200, 200, 1)",
                    },
                  }}
                  variant="contained"
                  loading={isLoading}
                  onClick={() => {
                    setIsLoading(true);
                    sendOtp(email, phone).then((res) => {
                      setIsOtpSent(true);
                      setIsLoading(false);
                    });
                  }}
                >
                  Get verification code
                </LoadingButton>
              )}

              {isOtpSent && (
                <>
                  <Typography variant="body2" sx={{ color: "black" }}>
                    You will receive verification code on{" "}
                    {loginType === "email" ? email : phone}
                  </Typography>
                  <Link
                    onClick={() => {
                      setIsOtpSent(false);
                      setValue("otp", "");
                    }}
                    sx={{ color: "black" }}
                  >
                    Change{" "}
                    {loginType === "email" ? "email address" : "phone number"}
                  </Link>
                  {/* <OtpInput value={getValues().otp} setValue={(val) => setValue('otp', val)} /> */}
                  <Controller
                    name="otp"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        {...field}
                        fullWidth
                        label="Verification code"
                        error={Boolean(error)}
                        helperText={error?.message}
                        sx={{
                          "& .MuiInputBase-input:hover": {
                            borderColor: "black !important",
                            color: "black",
                          },
                          "& .MuiInputBase-input": {
                            borderColor: "black !important",
                            color: "black",
                          },
                        }}
                      />
                    )}
                  />
                </>
              )}
            </Stack>
          </form>
        </DialogContent>

        <DialogActions>
          <LoadingButton
            size="large"
            fullWidth
            loading={isLoading}
            onClick={() => {
              setIsLoading(true);
              sendOtp(email, phone).then((res) => {
                setIsOtpSent(true);
                setIsLoading(false);
              });
            }}
            color="success"
            // sx={{
            //   color: "white",
            //   backgroundColor: theme.palette.success.light,
            // }}
          >
            Resend
          </LoadingButton>
          <LoadingButton
            onClick={handleSubmit(onSubmit)}
            disabled={!isValid}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            color="success"
            // sx={{ color: "white", backgroundColor: theme.palette.success.main }}
          >
            Login
          </LoadingButton>
        </DialogActions>
      </Dialog>

      {interviewoptionvisible && (
        <InterviewOptions username={name} phone={phone} />
      )}
    </>
  );
}
